import React from 'react';
import dynamic from 'next/dynamic';
import {useRouter} from 'next/router';

const CoachProfilePage = dynamic(() => import('../../js/pages/CoachProfilePage'), {ssr: false});

export default function Page() {
  const {query: {coach}} = useRouter();
  return <CoachProfilePage coach={coach} />;
}
